import { useEffect, useState, useRef } from 'react';
import { Box, Flex, Text, Container } from 'theme-ui';
import ContactCard from '~/components/Footer/ContactSection/Card';
import useWindowSize from '~/hooks/components/use-window-size';

const ContactFooter = ({ contact }) => {
  const [cardWidth, setCardWidth] = useState(null);
  const widestRef = useRef(null);
  const { width } = useWindowSize();

  useEffect(() => {
    if (widestRef.current) {
      setCardWidth(widestRef.current.offsetWidth);
    }
  }, [widestRef.current?.offsetWidth, width]);

  return (
    <Container variant="fullwidth" sx={{ px: ['2.4rem', '4rem'], py: ['4.8rem', '9.6rem'], backgroundColor: 'cloud' }}>
      <Flex
        sx={{
          backgroundColor: 'cloud',
          justifyContent: 'space-between',
          overflow: 'hidden',
          flexDirection: ['column', null, 'row'],
          alignItems: ['center', null, 'unset'],
          gap: '2.4rem',
          maxWidth: 'var(--max-width)',
          mx: 'auto',
        }}
      >
        <Text
          as="h4"
          variant="text.caps"
          sx={{
            width: ['100%', '50%', '20%'],
            textAlign: ['center', 'unset'],
            fontSize: ['2.2rem', '3.8rem'],
            lineHeight: 1,
            mb: ['5.5rem', null, 0],
          }}
        >
          {contact.title}
        </Text>
        <Box
          id={contact.slug}
          sx={{
            width: ['100%', '50vw', '65vw'],
            display: 'grid',
            gap: '2.4rem',
            gridTemplateColumns: ['1fr', null, 'repeat(2, 1fr)'],
          }}
        >
          {contact.media.map((card) => (
            <ContactCard width={cardWidth} card={card} key={card.id} />
          ))}
        </Box>
      </Flex>
    </Container>
  );
};

export default ContactFooter;
